import axios from "axios";

export async function subscribeNewsletter(userId, email, origin) {
  return axios
    .post(`/newsletter-subscriptions/${userId}/`, {
      email: email,
      origin: origin,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log("Something went wrong " + err);
      return err;
    });
}
